import InvestmentsExportModal from "./InvestmentsExportModal"

export default InvestmentsExportModal
